import { Component, HostListener, OnInit, OnDestroy, Inject, inject, signal, computed, DestroyRef } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IdleTimeoutDialogData } from './idle-timeout-dialog-data';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-idle-timeout-dialog',
    templateUrl: './idle-timeout-dialog.component.html',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatDialogModule]
})
export class IdleTimeoutDialogComponent implements OnInit, OnDestroy {
    // Services using inject()
    private idle = inject(Idle);
    private mdDialogRef = inject(MatDialogRef<IdleTimeoutDialogComponent>);
    private destroyRef = inject(DestroyRef);

    // Signals for reactive state
    countdown = signal(this.idle.getTimeout() * 1000);

    // Computed signals
    currentCountdown = computed(() => this.countdown());

    // Other properties
    idleTimeoutConfirm$: Subscription;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public idleTimeoutDialogData: IdleTimeoutDialogData
    ) { }

    ngOnInit() {
        this.idleTimeoutConfirm$ =
            this.idle.onTimeoutWarning
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((countdowntime) => {
                    this.countdown.set(countdowntime * 1000);
                });
    }


    ngOnDestroy() {
        if (this.idleTimeoutConfirm$) {
            this.idleTimeoutConfirm$.unsubscribe();
        }
    }


    close(value: any) {
        this.mdDialogRef.close(value);
    }

    resetTimer() {
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        this.idle.watch();
        this.close('continue');
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.close('ESC keydown');
    }
}
